import React, { SVGProps } from "react"

interface Props extends Exclude<SVGProps<SVGSVGElement>, "width" | "height" | "fill" | "stroke"> {
  size: number
  fillColor: string
}

export default function ArrowIcon() {
  return <div>you must declare sub component of ArrowIcon.</div>
}

ArrowIcon.Left = Left
ArrowIcon.Right = Right
ArrowIcon.LeftCircleOutline = LeftCircleOutline
ArrowIcon.RightCircleOutline = RightCircleOutline

function Left() {}

function Right({ size, fillColor, ...props }: Props) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7071 3.4594C10.3166 3.06887 9.68342 3.06887 9.29289 3.4594C8.90237 3.84992 8.90237 4.48309 9.29289 4.87361L13.4191 8.99984H4.16663C3.61434 8.99984 3.16663 9.44755 3.16663 9.99984C3.16663 10.5521 3.61434 10.9998 4.16663 10.9998H13.4191L9.29289 15.1261C8.90237 15.5166 8.90237 16.1498 9.29289 16.5403C9.68342 16.9308 10.3166 16.9308 10.7071 16.5403L16.5404 10.7069C16.6493 10.5981 16.7278 10.4703 16.776 10.3343C16.8032 10.2576 16.8213 10.1767 16.829 10.0927C16.8424 9.94899 16.8247 9.80294 16.776 9.66541C16.7278 9.52934 16.6493 9.4016 16.5404 9.29273L10.7071 3.4594Z"
        fill={fillColor}
      />
    </svg>
  )
}

function LeftCircleOutline({ size, fillColor, ...props }: Props) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g filter="url(#filter0_d_2652_3020)">
        <circle r="19" transform="matrix(-1 0 0 1 24 22)" stroke={fillColor} stroke-width="2" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M23.293 15.4596C23.6835 15.0691 24.3167 15.0691 24.7072 15.4596C25.0978 15.8502 25.0978 16.4833 24.7072 16.8739L20.581 21.0001H29.8335C30.3858 21.0001 30.8335 21.4478 30.8335 22.0001C30.8335 22.5524 30.3858 23.0001 29.8335 23.0001H20.581L24.7072 27.1263C25.0978 27.5168 25.0978 28.15 24.7072 28.5405C24.3167 28.931 23.6835 28.931 23.293 28.5405L17.4597 22.7072C17.3508 22.5983 17.2723 22.4706 17.2241 22.3345C17.1969 22.2579 17.1788 22.1769 17.1711 22.0929C17.1578 21.9492 17.1754 21.8032 17.2241 21.6657C17.2723 21.5296 17.3508 21.4018 17.4597 21.293L23.293 15.4596Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2652_3020"
          x="0"
          y="0"
          width="48"
          height="48"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2652_3020" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2652_3020" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}

function RightCircleOutline({ size, fillColor, ...props }: Props) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g filter="url(#filter0_d_2652_3017)">
        <circle cx="24" cy="22" r="19" stroke={fillColor} stroke-width="2" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24.707 15.4596C24.3165 15.0691 23.6833 15.0691 23.2928 15.4596C22.9022 15.8502 22.9022 16.4833 23.2928 16.8739L27.419 21.0001H18.1665C17.6142 21.0001 17.1665 21.4478 17.1665 22.0001C17.1665 22.5524 17.6142 23.0001 18.1665 23.0001H27.419L23.2928 27.1263C22.9022 27.5168 22.9022 28.15 23.2928 28.5405C23.6833 28.931 24.3165 28.931 24.707 28.5405L30.5403 22.7072C30.6492 22.5983 30.7277 22.4706 30.7759 22.3345C30.8031 22.2579 30.8212 22.1769 30.8289 22.0929C30.8422 21.9492 30.8246 21.8032 30.7759 21.6657C30.7277 21.5296 30.6492 21.4018 30.5403 21.293L24.707 15.4596Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2652_3017"
          x="0"
          y="0"
          width="48"
          height="48"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2652_3017" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2652_3017" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}
